import styled from "styled-components";

export const PageContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f8f9fa;
`;

export const ContentContainer = styled.div`
  flex: 1;
  max-width: 900px;
  margin: 0 auto;
  padding: 7rem 2rem 4rem;
  width: 100%;
`;

export const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 800;
  color: #2c3e50;
  margin-bottom: 0.5rem;
  font-family: var(--font-poppins), sans-serif;
`;

export const LastUpdated = styled.p`
  font-size: 0.9rem;
  color: #7f8c8d;
  margin-bottom: 3rem;
`;

export const Section = styled.section`
  margin-bottom: 2.5rem;
`;

export const SectionTitle = styled.h2`
  font-size: 1.75rem;
  font-weight: 700;
  color: #c8553d;
  margin-bottom: 1rem;
  font-family: var(--font-poppins), sans-serif;
`;

export const SubsectionTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 1.5rem 0 0.75rem;
  font-family: var(--font-poppins), sans-serif;
`;

export const Paragraph = styled.p`
  font-size: 1rem;
  line-height: 1.8;
  color: #34495e;
  margin-bottom: 1rem;
`;

export const List = styled.ul`
  margin: 1rem 0;
  padding-left: 2rem;

  li {
    font-size: 1rem;
    line-height: 1.8;
    color: #34495e;
    margin-bottom: 0.5rem;
  }
`;
